<template>
	<div class="user_wrap">
		<div class="top_header">
			<div class="user_detail">
				<div class="user_header">
					<img src="../images/home/headDefault.png" alt="">
				</div>
				<div class="user_name">
					<div class="user_all" style="font-size: 14px;font-weight: 600;line-height: 30px;display: flex;align-items: center;">
						<p style="margin-left: 1em;margin-right: 5px;">{{data.name}}</p>
						<!-- <img v-if="acc && acc.vip" :src="acc.vip.img" style="width: 20px;" alt=""> -->
						
						<span style="font-size: 10px;
    font-weight: bold;
    color: #151515;
    display: block;
    padding: 3px 10px;
    line-height: 16px;
    background-color: #ffd424;
    border-radius: 10px;">
						{{acc.vip.name}}
						</span>
					</div>
					<div class="user_all">
						<p style="font-size: 12px;margin-left: 1em;">{{$t('d.creditscore')}}: {{acc.credit}}</p>
					</div>
					<div class="user_all">
						<p style="font-size: 12px;margin-left: 1em;">{{$t('d.code')}}: {{data.yaocode}}</p>
						<div v-clipboard="() => data.yaocode" v-clipboard:success="copy" class="copy-btn but2 flex-center" style="height: 25px;line-height: 20px;padding: 2px;padding-left: 8px;border-radius: 5px;margin-left: 10px;padding-right: 8px;font-size: 10px;box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);">{{$t('invest_bank.copy')}}</div>
					</div>
				</div>
				<div class="msg" @click="$router.push('/notice')">
					<van-icon v-if="acc&&acc.un_read_num>0" name="smile-comment" size="30" color="#fff" :badge="acc.un_read_num"/>
					<van-icon v-if="acc&&acc.un_read_num==0" name="smile-comment" size="30" color="#fff"/>
				</div>
			</div>
			
			<div class="user_money">
				<div class="border-bottom card-body">
					<div class="row">
					    <div class="col">
					        <h3 class="mb-0 font-weight-normal">
					            $ {{1*data.money}}
					        </h3>
					        <p class="text-mute">{{$t('d.balance')}}</p>
					    </div>
					    <div class="col-auto">
					        <van-icon @click="$router.push('/invest')" name="add" style="border-radius: 50px !important;" color="#fc494d" class="shadow" size="50px"/>
					    </div>
					</div>
				</div>
			    <div class="money_num">
			        <div>
						<p style="font-weight: 400; font-size: 15px; margin: 0px 5px;color: black;">
							$ {{1*data.frozenmoney}}
						</p>
						<div style="font-size: 12px;text-align: center;line-height: 30px;">
						{{$t('d.frozen')}}
						</div>
					</div>
					<div class="border-left-dotted">
						<p style="font-weight: 400; font-size: 15px; margin: 0px 5px;color: black;">
							$ {{1*data.reward}}
						</p>
						<div style="font-size: 12px;text-align: center;line-height: 30px;">
							{{$t('d.todayrewards')}}
						</div>
					</div>
			    </div>
			   <!-- <div class="user_but">
			        <div class="but_click but1" @click="$router.push('/cash')">
					{{$t('user.withdraw')}}
					</div>
			        <div class="but_click but2" @click="$router.push('/invest')">
					{{$t('moneybag.recharge')}}
					</div>
			    </div> -->
			</div>
		
			<!-- <div class="user_money">
				<div>
					<p style="font-size: 12px;">{{$t('invest.availableBalance')}}</p>
					<p>{{data.availmoney}} {{utils_moneyMark()}}</p>
				</div>
				<div>
					<p style="font-size: 12px;">{{$t('user.cumulativeIncome')}}</p>
					<p>+{{data.all_lixi}} {{utils_moneyMark()}}</p>
				</div>
			</div>
			 -->
			
			<!-- <router-link to="/moneybag" class="label">
			<div v-if="acc" class="main_quantity flex-between alcenter">
			    <div class="flex-one">
					<div class="des" style="margin-top: 10px;">
						{{$t('moneybag.accountBalance')}}
					</div>
			        <div class="c_26a763 ft53 word font-bold flex">
			            <div style="font-size: 16px;">{{acc.money}}</div>
			            <span class="ft28 ml10">{{utils_moneyMark()}}</span>
			        </div>
					<div class="des" style="margin-top: 10px;">
						{{$t('user.uncollectedPrincipal')}}
					</div>
			        <div class="c_26a763 ft53 word font-bold flex">
			            <div style="font-size: 16px;">{{acc.wait_money}}</div>
			            <span class="ft28 ml10">{{utils_moneyMark()}}</span>
			        </div>
					<div class="des">
						{{$t('user.uncollectedInterest')}}
					</div>
			        <div class="c_26a763 ft53 word font-bold flex">
			            <div style="font-size: 16px;">{{acc.wait_lixi}}</div>
			            <span class="ft28 ml10">{{utils_moneyMark()}}</span>
			        </div>
			        <div class="des">
						{{$t('item.depositqdesc')}}
			        </div>
			    </div>
			    <div>
			        <div style="background-image: url('../images/trading/user2.png'); background-position: 0% 0%; background-size: 100% 100%; background-repeat: no-repeat;"></div>
			        <img src="../images/trading/user2.png" draggable="true">
				</div>
			</div>
			</router-link> -->
			<!-- <div class="user_balance"  v-if="eye==1">
				<div style="display: flex;text-align: center;">
					<span style="width: 50%;">{{$t('moneybag.accountBalance')}}</span>
					<span style="width: 50%;">
						{{$t('moneybag.availmoney')}}
						<van-icon name="eye-o" @click="eye=0"/>
					</span>
				</div>
				<div style="display: flex;text-align: center;">
					<span style="width: 50%;">
						{{utils_moneyMark()}}{{data.money}}
					</span>
					<span style="width: 50%;">
						{{utils_moneyMark()}}{{data.availmoney}}
					</span>
				</div>
			</div>
			<div class="user_balance"  v-if="eye==0">
				<div style="display: flex;text-align: center;">
					<span style="width: 50%;">{{$t('moneybag.accountBalance')}}</span>
					<span style="width: 50%;">
						{{$t('moneybag.availmoney')}}
						<van-icon name="eye-o" @click="eye=1"/>
					</span>
				</div>
				<div style="display: flex;text-align: center;">
					<span style="width: 50%;">
						******
					</span>
					<span style="width: 50%;">
						******
					</span>
				</div>
			</div>
			<div class="user_money" v-if="eye==1">
				<div>
					<p style="font-size: 12px;">{{$t('user.uncollectedPrincipal')}}</p>
					<p>+{{utils_moneyMark()}}{{data.wait_money}}</p>
				</div>
				<div>
					<p style="font-size: 12px;">{{$t('user.uncollectedInterest')}}</p>
					<p>+{{utils_moneyMark()}}{{data.wait_lixi}}</p>
				</div>
				<div>
					<p style="font-size: 12px;">{{$t('user.cumulativeIncome')}}</p>
					<p>+{{utils_moneyMark()}}{{data.all_lixi}}</p>
				</div>
			</div>
			<div class="user_money" v-if="eye==0">
				<div>
					<p style="font-size: 12px;">{{$t('user.uncollectedPrincipal')}}</p>
					<p>******</p>
				</div>
				<div>
					<p style="font-size: 12px;">{{$t('user.uncollectedInterest')}}</p>
					<p>******</p>
				</div>
				<div>
					<p style="font-size: 12px;">{{$t('user.cumulativeIncome')}}</p>
					<p>******</p>
				</div>
			</div> -->
		</div>
		
		<div class="user_invite">
<!-- 		    <div class="invite_text">
				<p>{{$t('shopds.invitef')}}</p>
		        <span style="color: rgba(255, 255, 255, 0.6); font-size: 12px;"><span>
				{{$t('shopds.invitationdes')}}</span>
		        </span>
		    </div>
		    <div @click="$router.push('/myteam')">{{$t('shopds.invitation')}}</div> -->
		</div>
		<div class="list" >
			<van-grid :column-num="3">
			  
			  <van-grid-item to="/grap" icon="cart" :text="$t('shopd.grab')" />
			  <van-grid-item to="/invest" icon="peer-pay" :text="$t('moneybag.recharge')" />
			  <van-grid-item to="/cash" icon="share-o" :text="$t('user.withdraw')" />
			  <van-grid-item to="/moneybag" icon="paid" :text="$t('user.myWallet')" />
			  <van-grid-item to="/cashlist" icon="certificate" :text="$t('user.withdrawalRecord')" />
			  <van-grid-item to="/myTeam" icon="friends-o" :text="$t('index.invite')" />
			  <van-grid-item to="/addr" icon="manager" :text="$t('shopd.readdr')" />
			  <van-grid-item to="/setpwd" icon="lock" :text="$t('safe.signInPassword')" />
			  <van-grid-item to="/notice" icon="smile-comment" :text="$t('notice.message')" />
			  <van-grid-item to="/about" icon="info" :text="$t('index.aboutUs')" />
			  <van-grid-item to="/setpaypwd" icon="shield-o" :text="$t('safe.paymentPassword')" />
			  <van-grid-item to="/language" icon="other-pay" :text="$t('safe.language')" />
			  <!-- <van-grid-item @click="logout" icon="weapp-nav" :text="$t('safe.signOut')" /> -->
			</van-grid>
		</div>
		<div style="margin-top:0px;padding-bottom: 100px;">	
			<div class="history_coupon flex_center basic_btn" @click="logout">
				<span>{{$t('safe.signOut')}}</span>
			</div>
		</div>
		<van-popup
		v-model="show"
		round 
		:style="{ 'line-height': '30px',
			'width': '70%',
			'padding': '15px',
			'font-weight': 'bold'}"
		>{{msg}}</van-popup>
		<div
		    v-if="msg_show"
		    class="kefu"
		    :class="show_kefu ? '' : 'kefu_hide'"
		    @click="kefu_to"
		>
		    <img class="kefu_img" src="../images/shop2/kefu.jpg" />
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import qs from 'qs';
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index";
	import {
		Icon,
		Cell, 
		CellGroup ,
		Grid,
		GridItem,
		Popup,
	} from "vant";
	Vue.use(Cell).use(Grid).use(GridItem).use(CellGroup).use(Icon).use(Popup);
	import Clipboard from "v-clipboard";
	Vue.use(Clipboard);
	export default {
		name: "user",
		components: {
		},
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn",
				data: {},
				show_kefu: false,
				msg_show: true,
				acc:null,
				msg:null,
				show:false,
				app:null,
				eye:1
			};
		},
		created() {
			this.$parent.footer('user');
		},
		mounted() {
			this.start();
			var that = this;
			document.body.addEventListener(
			    "scroll",
			    function() {
			        if (!that.show_kefu) {
			            return;
			        }
			        that.show_kefu = false;
			    },
			    false
			);
			document.addEventListener(
			    "click",
			    function(ev) {
			        if (ev.target.className != "kefu_img") {
			            that.show_kefu = false;
			        }
			    },
			    false
			);
		},
		methods: {
			sync() {
				Fetch("/index/sync", {}, null, false).then((r) => {
					var data = r.data;
					if(data && data.length>0){
						this.msg = data[0].content;
						this.show= true;
						setTimeout(()=>{
						  Fetch('/user/notice_view', {
						  	id: data[0].id
						  }).then(res => {
						  })
						},2000);
					}
				});
			},
			kefu_to() {
			    if (this.show_kefu) {
					// var link = this.app.kefu_link + '&uid='+this.acc.uid+ '&name='+this.acc.mobile;
					var link = this.app.kefu_link ;
					// window.location.href = link;
			        this.$router.push("/kefu");
			    }
			    this.show_kefu = !this.show_kefu;
			},
			downapp() {
			    top.location.href='/app.apk';
			},
			copy() {
				this.$toast({
					background: "#07c160",
					message: this.$t('invest_qrcode.copySucceeded'),
				});
			},
			start() {
				Fetch('/index/webconfig').then((r)=>{
					this.app = r.data;
				});
				Fetch('/user/info').then((r) => {
					this.data = r.data;
					this.acc = r.data;
				});
				setTimeout(()=>{
				  this.sync()
				},2000)
			},
			logout() {
				localStorage.removeItem('token');
				this.$router.replace("/");
			}
		}
	};
</script>

<style lang="less" scoped>
	.user_wrap {
		max-width: 100%;
	}
	.top_header {
		position: relative;
		width: 100%;
		height: 130px;
		background-size: 100% 100%;
		background: #fc494d;
		.set_go{
			width: 38px;
			height: 38px;
			position: absolute;
			top: 11px;
		}
		
		.set_go {
			right: 14px;
			background: url(../images/user/sign.png) no-repeat center center;
			background-size: 100% 100%;
		}
		.user_detail {
			width: 100%;
			padding: 15px 15px 0 15px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			.user_header {
				width: 60px;
				height: 60px;
				overflow: hidden;
				border-radius: 50%;
				border: 1px solid rgba(255, 255, 255, 0.3);
				img {
					width: 100%;
					height: 100%;
				}
			}
			.user_name {
				margin-left: 3px;
				margin-top: 3px;
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				color: #FFFFFF;
				.user_all {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					.user_nickname {
						line-height: 1.6em;
						font-size: 1.2em;
						margin-left: 1em;
					}
				}
			}
		}
		.user_vip{
			color: #FFFFFF;
			font-weight: bold;
			font-size: 16px;
			margin: 10px 20px 20px 20px;
		}
		.user_balance{
			text-align: center;
			div{
				margin: 10px 0;
			}
			div:nth-child(1){
				font-size: 14px;
				color: #d3d5d6;
			}
			div:nth-child(2){
				font-weight: bold;
				font-size: 18px;
				color: #FFFFFF;
			}
		}
		.user_money{
			justify-content: space-between;
			text-align: center;
			
		}
	}
	.kong{
		width: 100%;
		height: 35px;
	}
	.history_coupon{
		margin: 30px auto 0 auto;
		width:356px;
		border-radius:5px;
		text-align: center;
		span{
			font-size: 14px;
			height: 20px;
			line-height: 20px;
			position: relative;
			&::after{
				content: '';
				position: absolute;
				top: 3px;
				right: -25px;
				width: 12px;
				height: 13px;
				background: url(../images/user/more.png) no-repeat center center;
				background-size: 100% 100%;
			}
		}
	}
	.user_yw{
		display: flex;
		justify-content: space-between;
		text-align: center;
		width: 96%;
		position: relative;
		background: #FFFFFF;
		left: 2%;
		border-radius: 5px 5px 0 0;
		padding: 15px 0;
		position: relative;
		div{
			width: 50%;
		}
		p{
			margin-top: 8px;
		}
		img {
			height: 50px;
		}
	}
	.money{
		display: flex;
		justify-content: space-between;
		width: 96%;
		background: #FFFFFF;
		border-radius: 5px;
		margin-top: -73px;
		margin-left: 2%;
		padding: 15px;
		div:nth-child(1){
			width: 40%;
			text-align: left;
			p:nth-child(1){
				color: #999;
				margin-bottom: 10px;
			}
			p:nth-child(2){
				font-size: 14px;
				font-weight: bold;
			}
		}
		div:nth-child(2){
			width: 60%;
			text-align: right;
			margin-top: 12px;
			span{
				padding: 5px 10px;
				border-radius: 5px;
				margin: 0 5px;
			}
			span:nth-child(1){
				color: #FFFFFF;
				background: #3775f4;
			}
			span:nth-child(2){
				color: #3775f4;
				background: #e9f0fb;
			}
		}
	}
	.list{
		width: 90%;
		margin-left: 5%;
		padding: 5px;
		background-color: #FFF;
		border-radius: 3%;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
		img{
			vertical-align: middle;
			height: 30px;
			margin-right: 10px;
		}
	}
	.main_quantity{
	    width: 100%;
	    overflow: hidden;
	    border-radius: 10px;
	    padding: 15px;
	    box-sizing: border-box;
		.title{
		    align-items: flex-end;
		    font-size: 16px;
		    color: #FFFFFF;
		    font-weight: 700;
		}
		.word{
		    align-items: flex-end;
		    margin-bottom: 10px;
		}
		.des{
		    font-size: 12px;
		    color: #FFFFFF;
		    line-height: 19px;
			width: 90%;
		}
		>div:nth-child(2){
		    width: 135px;
		    height: 168px;
			img{
				width: 100%;
				height: 100%;
			}
		}
	}
	.flex-one {
	    flex: 1;
	}
	.alcenter {
	    align-items: center;
	}
	.flex-between {
	    display: flex;
	    justify-content: space-between!important;
	}
	.ft28 {
	    font-size: 14px;
	}
	.ml10 {
	    margin-left: 5px;
	}
	.font-bold {
	    font-weight: 700;
	}
	.ft53 {
	    font-size: 25px;
	}
	.c_26a763 {
	    color: #FFFFFF;
	}
	.flex {
	    display: flex;
	}
	.user_invite{
	    width: 90%;
	    // background: url(../images/user/backimg.jpg);
	    background-size: 100%;
	    border-radius: 10px;
	    margin: 3% 5%;
	    padding: 5px;
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	    color: #fff;
		margin-top: 120px;
		.invite_text{
		    width: 64%;
			display: block;
			p{
				font-size:16px;
			}
		}
		span{
			color: rgba(255, 255, 255, 0.6);
			font-size: 12px;
			line-height: 1.8em;
		}
		>div:last-child {
		    width: 30%;
		    height: 31px;
		    background-color: #ffcd00;
		    border-radius: 26px;
		    display: flex;
		    justify-content: center;
		    align-items: center;
		    font-size: 14px;
		}
	}
	.user_money{
		display: block;
	    width: 90%;
	    margin-left: 5%;
	    background-color: #fff;
	    border-radius: 10px;
	    padding: 15px;
	    margin-top: 10px;
	    // background: url(../images/user/smallBackground.png) no-repeat;
	    background-size: cover;
	    background-position: 50%;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
		.money_num{
		    width: auto;
		    height: 40px;
		    display: flex;
		    align-items: center;
		    justify-content: space-between;
		    font-size: 12px;
			p{
				margin: 10px 0;
			}
			div{
				width: 100%;
			}
			p:nth-child(2){
				font-size: 14px;
				color: #d3d5d6;
			}
			p:nth-child(1){
				font-size: 18px;
				font-weight: 700;
				color: #FFFFFF;
			}
			>div:first-child {
			    // display: flex;
			    align-items: center;
				img{
				    width: 20px;
				    height: 20px;
					display: inline-block;
					overflow: hidden;
					position: relative;
				}
				p{
					font-weight: bold;
					color: #000000e6;
					font-size: 17px;
					margin: 0px 5px;
				}
			}
		}
		.user_but{
		    display: flex;
		    justify-content: space-around;
		    align-items: center;
			.but_click{
			    width: 45%;
			    height: 40px;
			    border-radius: 10px;
			    display: flex;
			    align-items: center;
			    justify-content: center;
			}
		}
	}
	/deep/ .van-cell {
		 padding: 10px 8px;
	}
	
	.border-left-dotted {
	    border-left: 1px dashed rgba(0, 0, 0, 0.1) !important;
	}
	
	.border-top, .border-left, .border-bottom, .border-right {
		border-color: rgba(0, 0, 0, 0.1) !important;
	}
	.card-body {
	    -ms-flex: 1 1 auto;
	    flex: 1 1 auto;
	    min-height: 1px;
		padding: 15px;
		border-bottom: solid 1px;
		margin-bottom: 15px;
		padding-top: 0px;
		padding-bottom: 10px;
	}
	.row {
	    display: -ms-flexbox;
	    display: flex;
	    -ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	    margin-right: -15px;
	    margin-left: -15px;
	}
	.col {
	    -ms-flex-preferred-size: 0;
	    flex-basis: 0;
	    -ms-flex-positive: 1;
	    flex-grow: 1;
	    max-width: 100%;
		text-align: left;
	}
	.font-weight-normal {
	    font-weight: 400!important;
	}
	.mb-0, .my-0 {
	    margin-bottom: 0!important;
	}
	h3 {
	    font-size: 30px;
		line-height: 36px;
	}
	.col-auto {
	    -ms-flex: 0 0 auto;
	    flex: 0 0 auto;
	    width: auto;
	    max-width: 100%;
	}
	.text-mute {
	    opacity: 0.7;
		font-size: 16px;
		line-height: 22px;
	}
</style>
